export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    properties: {
      org: {
        title: 'Name of Organization',
        type: 'string'
      },
      checkbox: {
        type: 'boolean',
        title: 'Checkbox'
      },
      awardorg: {
        type: 'string',
        title: 'Awarding Organization Is',
        enum: ['642265', '642266', '642267', '642268', '642269', '642270'],
        enumNames: ['Your University', 'Local', 'State', 'Federal', 'Private', 'Other'],
        maxLength: 20000
      },
      status: {
        type: 'string',
        title: 'Current Status',
        enum: ['642378', '642379', '642380'],
        enumNames: ['Currently Under Review', 'Funded', 'Not Funded'],
        maxLength: 20000
      },
      npresp: {
        title: 'Normal Professional Responsibility',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Administration', 'Doctoral Level Teaching/Mentoring', 'Executive Education', 'Graduate Teaching', "Master's Level Teaching", 'Non-Credit Teaching', 'Research', 'Undergraduate Teaching', 'Other Service and Outreach Responsibilities'],
          enumNames: ['Administration', 'Doctoral Level Teaching/Mentoring', 'Executive Education', 'Graduate Teaching', "Master's Level Teaching", 'Non-Credit Teaching', 'Research', 'Undergraduate Teaching', 'Other Service and Outreach Responsibilities']
        }
      },
      description: {
        title: 'Description',
        type: 'string',
        maxLength: 20000
      },
      number: {
        title: 'Integer',
        type: 'integer'
      },
      double: {
        title: 'Double',
        type: 'number'
      },
      percent: {
        title: 'Percent',
        type: 'number'
      },
      currency: {
        title: 'Currency',
        type: 'number'
      },
      numberConstrained1: {
        title: 'Integer - between 5 and 10',
        type: 'integer',
        minimum: 5,
        maximum: 10
      },
      numberConstrained2: {
        title: 'Integer - under 100',
        type: 'integer',
        maximum: 99
      },
      numberConstrained3: {
        title: 'Integer - under 10000',
        type: 'integer',
        maximum: 9999
      },
      doubleConstrained: {
        title: 'Double - between 2.71 and 3.14',
        type: 'number',
        minimum: 2.71,
        maximum: 3.14
      },
      percentConstrained: {
        title: 'Percent - whole number between 0 and 100',
        type: 'integer',
        minimum: 0,
        maximum: 100
      },
      currencyConstrained: {
        title: 'Currency - between 0.25 and 100,000.25',
        type: 'number',
        minimum: 0.25,
        maximum: 100000.25
      },
      percentHidden: {
        title: 'Percent - hidden',
        type: 'integer'
      },
      percentReadOnly: {
        title: 'Percent - read only',
        type: 'integer'
      },
      percentLocked: {
        title: 'Percent - locked',
        type: 'integer'
      },
      currencyHidden: {
        title: 'Currency - hidden',
        type: 'number'
      },
      currencyReadOnly: {
        title: 'Currency - read only',
        type: 'number'
      },
      currencyLocked: {
        title: 'Currency - locked',
        type: 'number'
      },
      numberSuppressFormatting: {
        title: 'Integer - formatting suppressed',
        type: 'integer'
      },
      doubleSuppressFormatting: {
        title: 'Double - formatting suppressed',
        type: 'number'
      },
      static_unlabelled_1000: {
        type: 'object',
        properties: {
          sample_question_1001: {
            type: 'string',
            title: 'Sample Question',
            maxLength: 20000
          }
        },
        required: [],
        dependencies: {},
        additionalProperties: false,
        title: ''
      },
      static_labelled_2000: {
        type: 'object',
        properties: {
          sample_question_2001: {
            type: 'string',
            title: 'Sample Question',
            maxLength: 20000
          }
        },
        required: ['sample_question_2001'],
        dependencies: {},
        additionalProperties: false,
        title: 'Labelled Static Component'
      }
    }
  },
  uiSchema: {
    org: {
      'ui:widget': 'text',
      'ui:help': 'Some help text'
    },
    checkbox: {
      'ui:widget': 'checkbox'
    },
    awardorg: {
      'ui:widget': 'select'
    },
    status: {
      'ui:widget': 'radio'
    },
    npresp: {
      'ui:widget': 'checkboxes'
    },
    description: {
      'ui:widget': 'textarea'
    },
    standardNumericFieldsHeader: {
      'ui:title': {
        text: '<b>Standard Numeric Fields</b>',
        escape: false
      }
    },
    number: {
      'ui:widget': 'text'
    },
    double: {
      'ui:widget': 'text'
    },
    percent: {
      'ui:widget': 'text',
      'ui:options': {
        after: '%'
      }
    },
    currency: {
      'ui:widget': 'text',
      'ui:options': {
        before: '$',
        currency: 'USD'
      }
    },
    constrainedNumericFieldsHeader: {
      'ui:title': {
        text: '<b>Numeric Fields with Min/Max</b>',
        escape: false
      }
    },
    numberConstrained1: {
      'ui:widget': 'text'
    },
    numberConstrained2: {
      'ui:widget': 'text'
    },
    numberConstrained3: {
      'ui:widget': 'text'
    },
    doubleConstrained: {
      'ui:widget': 'text'
    },
    percentConstrained: {
      'ui:widget': 'text',
      'ui:options': {
        after: '%'
      }
    },
    currencyConstrained: {
      'ui:widget': 'text',
      'ui:options': {
        before: '$',
        currency: 'USD'
      }
    },
    restrictedNumericFieldsHeader: {
      'ui:title': {
        text: '<b>Restricted Numeric Fields</b>',
        escape: false
      }
    },
    percentHidden: {
      'ui:widget': 'text',
      'ui:options': {
        after: '%',
        icons: ['HIDDEN']
      }
    },
    percentReadOnly: {
      'ui:widget': 'text',
      'ui:options': {
        after: '%',
        icons: ['READ_ONLY']
      }
    },
    percentLocked: {
      'ui:widget': 'text',
      'ui:disabled': true,
      'ui:options': {
        after: '%',
        icons: ['LOCKED']
      }
    },
    currencyHidden: {
      'ui:widget': 'text',
      'ui:readonly': true,
      'ui:options': {
        before: '$',
        currency: 'USD',
        icons: ['HIDDEN']
      }
    },
    currencyReadOnly: {
      'ui:widget': 'text',
      'ui:readonly': true,
      'ui:options': {
        before: '$',
        currency: 'USD',
        icons: ['READ_ONLY']
      }
    },
    currencyLocked: {
      'ui:widget': 'text',
      'ui:disabled': true,
      'ui:options': {
        before: '$',
        currency: 'USD',
        icons: ['LOCKED']
      }
    },
    suppressFormatNumericFieldsHeader: {
      'ui:title': {
        text: '<b>Numeric Fields with Formatting Suppressed</b>',
        escape: false
      }
    },
    numberSuppressFormatting: {
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    doubleSuppressFormatting: {
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    static_unlabelled_1000: {
      'dm:layout': [{
        id: 'sample_question_1001',
        type: 'field'
      }],
      sample_question_1001: {
        'ui:title': {
          text: 'Sample Question',
          escape: true
        },
        'ui:widget': 'text'
      }
    },
    static_labelled_2000: {
      'dm:layout': [{
        id: 'sample_question_2001',
        type: 'field'
      }],
      sample_question_2001: {
        'ui:title': {
          text: 'Sample Question',
          escape: true
        },
        'ui:widget': 'text'
      }
    },
    'dm:layout': [{
      type: 'field',
      id: 'org'
    }, {
      id: 'checkbox',
      type: 'field'
    }, {
      id: 'awardorg',
      type: 'field'
    }, {
      id: 'status',
      type: 'field'
    }, {
      type: 'field',
      id: 'npresp'
    }, {
      type: 'field',
      id: 'description'
    }, {
      type: 'text',
      id: 'standardNumericFieldsHeader'
    }, {
      type: 'field',
      id: 'number'
    }, {
      type: 'field',
      id: 'double'
    }, {
      type: 'field',
      id: 'percent'
    }, {
      type: 'field',
      id: 'currency'
    }, {
      type: 'text',
      id: 'constrainedNumericFieldsHeader'
    }, {
      type: 'field',
      id: 'numberConstrained1'
    }, {
      type: 'field',
      id: 'numberConstrained2'
    }, {
      type: 'field',
      id: 'numberConstrained3'
    }, {
      type: 'field',
      id: 'doubleConstrained'
    }, {
      type: 'field',
      id: 'percentConstrained'
    }, {
      type: 'field',
      id: 'currencyConstrained'
    }, {
      type: 'text',
      id: 'restrictedNumericFieldsHeader'
    }, {
      type: 'field',
      id: 'percentHidden'
    }, {
      type: 'field',
      id: 'percentReadOnly'
    }, {
      type: 'field',
      id: 'percentLocked'
    }, {
      type: 'field',
      id: 'percentDisabled'
    }, {
      type: 'field',
      id: 'currencyHidden'
    }, {
      type: 'field',
      id: 'currencyReadOnly'
    }, {
      type: 'field',
      id: 'currencyLocked'
    }, {
      type: 'text',
      id: 'suppressFormatNumericFieldsHeader'
    }, {
      type: 'field',
      id: 'numberSuppressFormatting'
    }, {
      type: 'field',
      id: 'doubleSuppressFormatting'
    }, {
      id: 'static_unlabelled_1000',
      type: 'field'
    }, {
      id: 'static_labelled_2000',
      type: 'field'
    }]
  },
  formData: {},
  nodeData: {
    org: {
      code: 'ORG',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_TEXT'
      }
    },
    checkbox: {
      code: 'CHECKBOX',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_BOOLEAN'
      }
    },
    awardorg: {
      code: 'AWARDORG',
      optionCategory: {
        title: 'Awarding Organization',
        values: ['Your University', 'Local', 'State', 'Federal', 'Private', 'Other']
      },
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_TEXT',
        display: 'SELECT'
      }
    },
    status: {
      code: 'STATUS',
      optionCategory: {
        title: 'Current Status',
        values: ['Currently Under Review', 'Funded', 'Not Funded']
      },
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_TEXT',
        display: 'SELECT'
      }
    },
    npresp: {
      code: 'NPRESP',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_TEXT',
        display: 'CHECKBOX'
      },
      optionCategory: {
        title: 'Normal Professional Responsibilities',
        values: ['Administration', 'Doctoral Level Teaching/Mentoring', 'Executive Education', 'Graduate Teaching', "Master's Level Teaching", 'Non-Credit Teaching', 'Research', 'Undergraduate Teaching', 'Other Service and Outreach Responsibilities']
      }
    },
    description: {
      code: 'DESCRIPTION',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_TEXT',
        display: 'TEXT_AREA'
      }
    },
    number: {
      code: 'NUMBER',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_INTEGER'
      }
    },
    double: {
      code: 'DOUBLE',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE'
      }
    },
    percent: {
      code: 'DOUBLE',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        UNIT: 'PERCENTAGE'
      }
    },
    currency: {
      code: 'DOUBLE',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        UNIT: 'CURRENCY'
      }
    },
    numberConstrained1: {
      code: 'NUMBERCONSTRAINED1',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_INTEGER',
        MIN: 5,
        MAX: 10
      }
    },
    numberConstrained2: {
      code: 'NUMBERCONSTRAINED1',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_INTEGER',
        MAX: 99
      }
    },
    numberConstrained3: {
      code: 'NUMBERCONSTRAINED3',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_INTEGER',
        MAX: 9999
      }
    },
    doubleConstrained: {
      code: 'DOUBLECONSTRAINED',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        MIN: 2.71,
        MAX: 3.14
      }
    },
    percentConstrained: {
      code: 'PERCENTCONSTRAINED',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        MIN: 0,
        MAX: 100,
        UNIT: 'PERCENTAGE'
      }
    },
    currencyConstrained: {
      code: 'CURRENCYCONSTRAINED',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        MIN: 0,
        MAX: 100,
        UNIT: 'CURRENCY'
      }
    },
    percentHidden: {
      code: 'PERCENTHIDDEN',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        ACCESS: 'HIDDEN',
        UNIT: 'PERCENTAGE'
      }
    },
    percentReadOnly: {
      code: 'PERCENTREADONLY',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        ACCESS: 'READ_ONLY',
        UNIT: 'PERCENTAGE'
      }
    },
    percentLocked: {
      code: 'PERCENTLOCKED',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        ACCESS: 'LOCKED',
        UNIT: 'PERCENTAGE'
      }
    },
    currencyHidden: {
      code: 'CURRENCYHIDDEN',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        ACCESS: 'HIDDEN',
        UNIT: 'CURRENCY'
      }
    },
    currencyReadOnly: {
      code: 'CURRENCYREADONLY',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        ACCESS: 'READ_ONLY',
        UNIT: 'CURRENCY'
      }
    },
    currencyLocked: {
      code: 'CURRENCYLOCKED',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE',
        ACCESS: 'LOCKED',
        UNIT: 'CURRENCY'
      }
    },
    numberSuppressFormatting: {
      code: 'NUMBERSUPPRESSFORMATTING',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_INTEGER'
      }
    },
    doubleSuppressFormatting: {
      code: 'DOUBLESUPPRESSFORMATTING',
      descriptors: {
        nodeId: 12345,
        type: 'QUESTION_DOUBLE'
      }
    },
    static_unlabelled_1000: {
      code: 'STATIC_UNLABELLED',
      descriptors: {
        nodeId: 1000,
        type: 'COMPONENT'
      },
      children: {
        sample_question_1001: {
          code: 'SAMPLE_QUESTION',
          descriptors: {
            nodeId: 1001,
            type: 'QUESTION_TEXT'
          }
        }
      }
    },
    static_labelled_2000: {
      code: 'STATIC_LABELLED',
      descriptors: {
        nodeId: 2000,
        type: 'COMPONENT'
      },
      children: {
        sample_question_2001: {
          code: 'SAMPLE_QUESTION',
          descriptors: {
            nodeId: 2001,
            type: 'QUESTION_TEXT'
          }
        }
      }
    }
  }
};